import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative h-[420px] md:h-[600px] w-full overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20artistic%20background%20with%20floating%20comic%20panels%20and%20colorful%20abstract%20waves%2C%20warm%20coral%20and%20golden%20gradients%2C%20dreamy%20atmosphere%2C%20digital%20art%20illustration%2C%20soft%20light%20effects%2C%20modern%20minimalist%20composition%2C%20clean%20and%20artistic%20vibe&width=1800&height=900&seq=hero-bg-hanman&orientation=landscape"
        alt="韩漫之家 - 免费韩国漫画在线阅读平台"
        title="韩漫之家 - 免费漫画大全"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4">
        <h1 className="text-2xl md:text-5xl font-heading font-bold text-background-50 mb-4 md:mb-6 max-w-4xl leading-tight">
          无遮挡下拉式韩漫阅读，<br className="hidden md:block" />极致纯净视觉享受
        </h1>
        <p className="text-sm md:text-lg text-background-100/90 mb-8 md:mb-10 max-w-2xl leading-relaxed">
          韩漫之家 · 海量免费韩国漫画大全 · 每日更新 · 恋爱、奇幻、动作、悬疑全品类覆盖
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/all"
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-full text-sm md:text-base font-medium hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            立即开始阅读
          </Link>
          <Link
            to="/category/romance"
            className="px-8 py-3 bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full text-sm md:text-base font-medium hover:bg-background-50/30 transition-all whitespace-nowrap cursor-pointer"
          >
            热门恋爱韩漫
          </Link>
        </div>
      </div>
    </section>
  );
}